import { HrmRequestFormResponse } from '@Types/api/form';
import { parseDateTime } from '@Utils/transformDateTime';

import { TypeDict } from 'types';

export const getLabel = (
  requestItem: HrmRequestFormResponse | undefined,
  findLeaveType: (statusNum: number) => TypeDict | undefined,
  dateFormat?: string
): string => {
  if (!requestItem) {
    return '';
  }

  const leaveType = findLeaveType(requestItem.leaveTypeID)?.codeDesc || '';
  const dateFrom = parseDateTime(requestItem.startDate, dateFormat);
  const dateTo = parseDateTime(requestItem.endDate, dateFormat);

  return `${leaveType} from ${dateFrom} To ${dateTo}`;
};
